import React from "react";
import "./Gear.css";
import { Link, useNavigate } from "react-router-dom";
const Gear = ({ gear }) => {
  const { _id, name, picture, Quantity, price, discription, supplier } = gear;
  const navigate = useNavigate();
  const navigateToGearDetail = (_id) => {
    navigate(`/gear/${_id}`);
  };
  return (
    <div>
      <div className="gear-information">
        <img src={picture} className="gear-img" alt="" />
        <h3 className="gear-name">Name:{name}</h3>
        <h5>Price: {price}</h5>
        <h5>Quantity: {Quantity}</h5>
        <h5>Supplier: {supplier}</h5>
        <h5>Description: {discription}</h5>
        <Link to="/inventory/:inventoryId">
          <button
            onClick={() => navigateToGearDetail(_id)}
            className="btn-update"
          >
            Update
          </button>
        </Link>
      </div>
    </div>
  );
};

export default Gear;
